export default {
  periods: "hrmis/payroll/periods",
  payslip: (period) => `hrmis/payroll/payslip/${period}`,
};
